import {
    SOURCE_TYPES,
    TARGET_TYPES,
    UPLOAD_TYPES
} from "@/pages/CreateConnection/constants/connectionTypes";
import {format} from "date-fns";

export class ConnectionRequestBuilder {
    constructor(sourceUpload, targetUpload, sourceType, targetType, filter, sourceUploadAccount, targetUploadAccount) {
        this.sourceUpload = sourceUpload
        this.targetUpload = targetUpload
        this.sourceType = sourceType
        this.targetType = targetType
        this.uploadFilter = filter
        this.sourceUploadAccount = sourceUploadAccount

        // Пока что не используется. Делается наперед в случае если придётся добавлять в выгрузку назначения аккаунт
        // (Пока что на бэке для аккаунта гугл таблиц нет отдельного поля

        this.targetUploadAccount = targetUploadAccount

        console.log("FILTER", this.uploadFilter)
    }

    build() {
        const requestBody = {}

        requestBody.sources = this.buildSources()
        requestBody.filter = this.buildFilter()
        requestBody.target = this.buildTarget()

        return requestBody
    }

    buildSources() {
        const sources = []

        if (this.sourceType === SOURCE_TYPES.GOOGLE_SHEETS) {
            return this.buildGoogleSheets(UPLOAD_TYPES.SOURCE)
        }
        if (this.sourceType === SOURCE_TYPES.YANDEX_DIRECT_STAT) {
            return [this.buildYandexDirect()]
        }
        if (this.sourceType === SOURCE_TYPES.VKONTAKTE_CAMPAIGN_STAT) {
            return [this.buildVKAds()]
        }
        if (this.sourceType === SOURCE_TYPES.BITRIX_UPLOAD) {
            return [this.buildBitrix()]
        }

        return sources
    }

    buildTarget() {
        const target = {}

        if (this.targetType === TARGET_TYPES.GOOGLE_SHEETS) {
            return this.buildGoogleSheets(UPLOAD_TYPES.TARGET)
        }

        return target
    }

    buildFilter() {
        // Bitrix filter is embedded in the source payload.
        if (this.sourceType === SOURCE_TYPES.BITRIX_UPLOAD) {
            return null
        }

        if (!this.uploadFilter?.conditions?.length) {
            return null
        }

        const filter = {
            condition_type: this.uploadFilter.conditionType,
            conditions: []
        }


        for (const condition of this.uploadFilter.conditions) {
            filter.conditions.push({
                column_index: condition.column.column_index,
                column_name: condition.column.column_value.toString(),
                criteria: condition.criteria.criteria_type,
                value_type: condition.criteria.value_type,
                value: condition.filter_value.data,
            })
        }
        return filter
    }

    buildGoogleSheets(uploadType) {
        if (uploadType === UPLOAD_TYPES.SOURCE) {
            let requestBody = []
            for (const file of this.sourceUpload) {
                requestBody.push({
                    spreadsheet_id: file.id,
                    tab_id: file.tab.sheetId.toString(),
                    include_header: !file.clearHeader
                })
            }
            return requestBody
        }
        if (uploadType === UPLOAD_TYPES.TARGET) {
            return {
                spreadsheet_id: this.targetUpload.spreadsheet_id,
                tab_id: this.targetUpload.tab_id,
                action_type: this.targetUpload.action_type,
            }
        }
    }

    buildYandexDirect() {
        let startDateBuf = null
        let endDateBuf = null
        let startDateOffset = null
        let endDateOffset = null
        let startDateOffsetType = null
        let endDateOffsetType = null
        if (this.sourceUpload.startDate.type === 'exact') {
            startDateBuf = format(this.sourceUpload.startDate.date, 'yyyy-MM-dd')
        }
        else if (this.sourceUpload.startDate.type === 'offset') {
            const multiplierStart = this.sourceUpload.startDate.offsetOperation?.type === 'MINUS' ? -1 : 1
            startDateOffset = this.sourceUpload.startDate.length * multiplierStart
            startDateOffsetType = this.sourceUpload.startDate.offsetName.type
        }
        if (this.sourceUpload.endDate.type === 'exact') {
            endDateBuf = format(this.sourceUpload.endDate.date, 'yyyy-MM-dd')
        }
        if (this.sourceUpload.endDate.type === 'offset') {
            const multiplierEnd = this.sourceUpload.endDate.offsetOperation?.type === 'MINUS' ? -1 : 1
            endDateOffset = this.sourceUpload.endDate.length * multiplierEnd
            endDateOffsetType = this.sourceUpload.endDate.offsetName.type
        }

        console.log("this.sourceUploadAccount.id", this.sourceUploadAccount)

        return {
            date_from: startDateBuf,
            offset_from: startDateOffset,
            offset_from_type: startDateOffsetType,
            date_to: endDateBuf,
            offset_to: endDateOffset,
            offset_to_type: endDateOffsetType,
            yandex_account: this.sourceUploadAccount.id
        }
    }

    buildVKAds() {
        let startDateBuf = null
        let endDateBuf = null
        let startDateOffset = null
        let endDateOffset = null
        let startDateOffsetType = null
        let endDateOffsetType = null
        if (this.sourceUpload.startDate.type === 'exact') {
            startDateBuf = format(this.sourceUpload.startDate.date, 'yyyy-MM-dd')
        }
        else if (this.sourceUpload.startDate.type === 'offset') {
            const multiplierStart = this.sourceUpload.startDate.offsetOperation?.type === 'MINUS' ? -1 : 1
            startDateOffset = this.sourceUpload.startDate.length * multiplierStart
            startDateOffsetType = this.sourceUpload.startDate.offsetName.type
        }
        if (this.sourceUpload.endDate.type === 'exact') {
            endDateBuf = format(this.sourceUpload.endDate.date, 'yyyy-MM-dd')
        }
        if (this.sourceUpload.endDate.type === 'offset') {
            const multiplierEnd = this.sourceUpload.endDate.offsetOperation?.type === 'MINUS' ? -1 : 1
            endDateOffset = this.sourceUpload.endDate.length * multiplierEnd
            endDateOffsetType = this.sourceUpload.endDate.offsetName.type
        }

        console.log("this.sourceUploadAccount.id", this.sourceUploadAccount)

        return {
            date_from: startDateBuf,
            offset_from: startDateOffset,
            offset_from_type: startDateOffsetType,
            date_to: endDateBuf,
            offset_to: endDateOffset,
            offset_to_type: endDateOffsetType,
            vkontakte_account: this.sourceUploadAccount.id
        }
    }

    buildBitrixDatePart(dateValue) {
        let date = null
        let offset = null
        let offsetType = null

        if (!dateValue) {
            return { date, offset, offsetType }
        }

        if (dateValue.type === 'exact' && dateValue.date) {
            date = format(dateValue.date, 'yyyy-MM-dd')
        } else if (dateValue.type === 'offset') {
            const multiplier = dateValue.offsetOperation?.type === 'MINUS' ? -1 : 1
            offset = (dateValue.length || 0) * multiplier
            offsetType = dateValue.offsetName?.type || null
        }

        return { date, offset, offsetType }
    }

    buildBitrixConditions(conditions = []) {
        return conditions
            .filter((condition) => condition?.field?.id && condition?.criteria?.criteria_type)
            .map((condition) => ({
                field_id: condition.field.id,
                criteria: condition.criteria.criteria_type,
                value_type: condition.criteria.value_type || condition.filter_value?.type || null,
                value: condition.filter_value?.data ?? null,
            }))
    }

    buildBitrix() {
        const domain = typeof this.sourceUploadAccount === 'string'
            ? this.sourceUploadAccount
            : (this.sourceUploadAccount?.domain || this.sourceUploadAccount?.id || null)

        const entityType = this.sourceUpload?.dataType
        const filter = this.sourceUpload?.filter || {}

        const source = {
            source_type: SOURCE_TYPES.BITRIX_UPLOAD,
            domain,
            entity_type: entityType,
        }

        const start = this.buildBitrixDatePart(filter.startDate)
        const end = this.buildBitrixDatePart(filter.endDate)

        if (entityType === 'DEALS' || entityType === 'LEADS' || entityType === 'CONTACTS') {
            source.date_field = filter.dateField || 'DATE_CREATE'
            source.date_from = start.date
            source.offset_from = start.offset
            source.offset_from_type = start.offsetType
            source.date_to = end.date
            source.offset_to = end.offset
            source.offset_to_type = end.offsetType
        }

        if (entityType === 'DEALS') {
            source.direction_ids = (filter.directions || []).map((item) => String(item.id))
            source.stage_ids = (filter.stages || []).map((item) => String(item.id))
            source.condition_type = filter.conditionType || 'AND'
            source.conditions = this.buildBitrixConditions(filter.conditions)
            return source
        }

        if (entityType === 'LEADS') {
            source.stage_ids = (filter.stages || []).map((item) => String(item.id))
            source.condition_type = filter.conditionType || 'AND'
            source.conditions = this.buildBitrixConditions(filter.conditions)
            return source
        }

        if (entityType === 'CONTACTS') {
            return source
        }

        return source
    }
}